import {simulationStockChart, SimulationStockChart} from "./chart/SimulationStockChartComponent";
import {stockChartManager, StockChartManager} from "./manager/SimulationStockChartManagerComponent";
import {StockChartService} from "./service/StockChartService";
import {SimulationChartPeriod, simulationChartPeriod} from "./chart/period/InterDayPeriodSelector";

export default angular.module("tfApp.trade-simulator.components.stock-chart", [])
                      .component(SimulationStockChart, simulationStockChart())
                      .component(StockChartManager, stockChartManager())
                      .component(SimulationChartPeriod, simulationChartPeriod())
                      .service(StockChartService.id, StockChartService)
                      .name;
